import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HOSTNAME } from "../../constant/host";
import { setAuthTokenToCookies } from "../../common/utils";
import { userApi } from "../accounts/authuser";

type SuccessResponse = {
  status: string;
  message: string;
};

type ConfirmResponse = SuccessResponse & {
  token: string;
};

export const passwordResetApi = createApi({
  reducerPath: "passwordResetApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOSTNAME,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    requestPasswordReset: builder.mutation<
      SuccessResponse,
      { email: string }
    >({
      query: (body) => ({
        url: "/api/password-reset/request",
        method: "POST",
        body,
      }),
    }),

    validateResetToken: builder.mutation<
      SuccessResponse,
      { uid: string; token: string }
    >({
      query: (body) => ({
        url: "/api/password-reset/validate",
        method: "POST",
        body,
      }),
    }),

    confirmPasswordReset: builder.mutation<
      ConfirmResponse,
      { uid: string; token: string; password: string; password_confirm: string }
    >({
      query: (body) => ({
        url: "/api/password-reset/confirm",
        method: "POST",
        body,
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.token) {
            setAuthTokenToCookies(data.token);
            dispatch(userApi.util.invalidateTags(["CurrentUser"]));
          }
        } catch {
          // エラー時は呼び出し側で処理
        }
      },
    }),
  }),
});

export const {
  useRequestPasswordResetMutation,
  useValidateResetTokenMutation,
  useConfirmPasswordResetMutation,
} = passwordResetApi;
